import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { isFlowEngineEnabledForProcess } from '../helpers/flowEngineConfigHelper';
import { composeFlowEditPageTitle } from '../helpers/flowEditPageTitleHelper';
import useActiveSpecialistRole from './useActiveSpecialistRole';

const useFlowEditPageTitle = (moduleProcess, pageKey = 'edit') => {
  const { t } = useTranslation();
  const configuration = useSelector((state) => state.configuration);
  const { roleKey } = useActiveSpecialistRole();
  const flowEnabled = isFlowEngineEnabledForProcess(configuration, moduleProcess);

  return composeFlowEditPageTitle({
    t,
    moduleProcess,
    pageKey,
    roleLike: roleKey,
    flowEnabled
  });
};

export default useFlowEditPageTitle;
